$('.show-password, .hide-password').on('click', function() {
  if ($(this).hasClass('show-password')) {
    $('.join-password').attr('type', 'text');
    $(this).parent().find('.show-password').hide();
    $(this).parent().find('.hide-password').show();
  } else {
    $('.join-password').attr('type', 'password');
    $(this).parent().find('.hide-password').hide();
    $(this).parent().find('.show-password').show();
  }
});
